import { useRouter } from 'next/router'
import {
  EventActions,
  EventCategories,
  EventNames,
  sendDigitalDataEvent,
} from '@cinch-nx/shared-analytics'
import { track } from '@cinch-labs/customer-data-segment'
import { FullWidthCTA, FullWidthCTAProps } from '@cinch-labs/design-system'
import { datadogRum } from '@datadog/browser-rum'
import styles from './pre-footer-cta-v2-wrapper.module.css'

const aboutCollectionsSearchAllCarsClick = () => {
  const evt = {
    event: {
      name: EventNames.click,
      category: EventCategories.button,
      action: EventActions.navigate,
      label: 'about collections page search',
    },
  }

  sendDigitalDataEvent(evt)
  datadogRum.addAction('AboutCollectionsSearchAllCarsClicked')
  track('Collections page search all cars', evt)
}

export const PreFooterCtaV2Wrapper: React.FC<FullWidthCTAProps> = (props) => {
  const router = useRouter()

  const onClickHandler = () => {
    aboutCollectionsSearchAllCarsClick()
    router.push('/used-cars')
  }

  return (
    <div className={styles.wrapper}>
      <FullWidthCTA {...props} onButtonClick={onClickHandler} />
    </div>
  )
}
